// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_c-1";
export var movingGradient = "_c-4";
export var movingGradientBlock = "_c-2";
export var skeleton = "_c-0";
export var skeletonText = "_c-3";